import { render, staticRenderFns } from "./project.vue?vue&type=template&id=c4f6edea"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "./project.vue?vue&type=style&index=0&id=c4f6edea&lang=scss"
import style1 from "./project.vue?vue&type=style&index=1&id=c4f6edea&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4f6edea')) {
      api.createRecord('c4f6edea', component.options)
    } else {
      api.reload('c4f6edea', component.options)
    }
    module.hot.accept("./project.vue?vue&type=template&id=c4f6edea", function () {
      api.rerender('c4f6edea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/games/project.vue"
export default component.exports